
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-open-ai-demo-open-ai-chat-provider","docs-x-sdk-chat-provider-open-ai-demo-openai"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.zh-CN.md?type=demo')
};